import apple from "./fruit/apple.jpg";
import banana from "./fruit/banana.jpg";
import peach from "./fruit/peach.jpg";
import orange from "./fruit/orange.jpg";
import pineapple from "./fruit/pineapple.jpg";
import mangoes from "./fruit/mangoes.jpg";
import strawberries from "./fruit/strawberries.jpg";
import kiwis from "./fruit/kiwis.jpg";
import logo from "./logo.jpg";
import refresh from "./refresh.jpg";
import favicon from "./favicon.png";
import ch2_fig1 from "./ch2/ch2_fig1.jpg";
import ch3_fig1 from "./ch3/ch3_fig1.jpg";
import ch3_fig2 from "./ch3/ch3_fig2.jpg";
import ch3_fig3 from "./ch3/ch3_fig3.jpg";
import ch3_fig4 from "./ch3/ch3_fig4.jpg";
import ch3_fig5 from "./ch3/ch3_fig5.jpg";
import ch3_fig6 from "./ch3/ch3_fig6.jpg";
import ch3_fig7 from "./ch3/ch3_fig7.jpg";
import ch3_fig8 from "./ch3/ch3_fig8.jpg";
import ch4_fig1 from "./ch4/ch4_fig1.jpg";
import ch4_fig2 from "./ch4/ch4_fig2.jpg";
import ch4_fig3 from "./ch4/ch4_fig3.jpg";
import ch5_fig1 from "./ch5/ch5_fig1.jpg";
import macLogo from "./macLogo.png";

const source = {
    apple,
    banana,
    peach,
    orange,
    pineapple,
    mangoes,
    strawberries,
    kiwis,
    logo,
    favicon,
    refresh,
    ch2_fig1,
    ch3_fig1,
    ch3_fig2,
    ch3_fig3,
    ch3_fig4,
    ch3_fig5,
    ch3_fig6,
    ch3_fig7,
    ch3_fig8,
    ch4_fig1,
    ch4_fig2,
    ch4_fig3,
    ch5_fig1,
    macLogo
};

export default source;


// WEBPACK FOOTER //
// ./src/images/ImagesControl.js